module.exports = __webpack_public_path__ + "static/media/detailWIRED.7be2ed0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/de/detailWIRED.png
// module id = 92
// module chunks = 0